import { inject } from 'mobx-react';
import ReactComponent from '../../ReactComponent';

class IconeLimpar extends ReactComponent {
    render() {
        return (
            <svg
                viewBox="0 0 20 17.499092"
                width="20"
                height="17.499092"
                {...this.props}
            >
                <path d="m 11.874902,0 c -0.479828,-4.1999282e-6 -0.960147,0.1842832 -1.32628,0.5503976 L 0.54914062,10.549879 c -0.73218749,0.732186 -0.73218749,1.918598 0,2.650785 L 4.2989461,16.95047 a 1.8750562,1.8750562 0 0 0 1.3262807,0.548622 H 19.530755 c 0.258853,0 0.468726,-0.209873 0.468726,-0.468726 v -1.562419 c 0,-0.258853 -0.209873,-0.468725 -0.468726,-0.468725 h -5.630034 l 5.550138,-5.5483626 c 0.732188,-0.732188 0.732188,-1.9185902 0,-2.6507859 L 13.201184,0.5503976 C 12.83509,0.1842999 12.35473,4.2000718e-6 11.874902,0 Z m -4.2451627,7.0042532 5.3654887,5.3654888 -2.62948,2.62948 H 5.8844463 l -3.124838,-3.124838 z" />
            </svg>
        );
    }
}

export default inject('stores')(IconeLimpar);
